import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'
import { TabConfig } from '../../../shared/components/tabs/tabs.component'
import { AccountService } from '../../services/account.service'
import { OnboardingService } from '../../services/onboarding.service'

@Component({
  selector: 'app-access-management-tabs',
  templateUrl: './access-management-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccessManagementTabsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()

  tabs: TabConfig[] = []
  baseRoute: string
  landingPageRoute: string
  showBackToWelcome = false

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public accountService: AccountService,
    private onboardingService: OnboardingService
  ) {}

  ngOnInit() {
    // Get accountId from parent route params
    const accountId = this.route.parent?.snapshot.paramMap.get('accountId')
    this.baseRoute = `/${accountId}/account/access-management`
    this.landingPageRoute = `/${accountId}/welcome`

    // Check if user came from welcome page
    this.showBackToWelcome = this.route.snapshot.queryParamMap.get('from') === 'welcome'

    // Always show all tabs to tease RBAC features
    this.tabs = [
      { label: 'Users', route: '' },
      { label: 'Roles', route: 'roles' },
      { label: 'Groups', route: 'groups' },
    ]

    // Track tab visits for onboarding
    this.trackCurrentTab()
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.trackCurrentTab()
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  navigateBackToWelcome() {
    this.router.navigateByUrl(this.landingPageRoute)
  }

  private trackCurrentTab() {
    // Strip query params for URL matching
    const url = this.router.url.split('?')[0]
    if (url.includes('/account/access-management/roles')) {
      this.onboardingService.markAccessManagementTabVisited('roles')
    } else if (url.endsWith('/account/access-management') || url.endsWith('/account/access-management/')) {
      this.onboardingService.markAccessManagementTabVisited('users')
    }
  }
}
